import React from 'react';
import { FaCodepen, FaStore, FaUserFriends, FaUsers } from 'react-icons/fa';
import {useEffect, useContext} from 'react'
import { Link } from 'react-router-dom';
import Spinner from '../components/layouts/Spinner';
import GithubContext from '../context/github/GithubContext';
import { useParams } from 'react-router-dom'
import RepoList from '../components/repos/RepoList';
import { getUserAndRepos } from '../context/github/GithubActions'

function User() {


    const { user, loading, repos, dispatch} = useContext(GithubContext)

    const params = useParams()

    useEffect(() =>{

       dispatch({type: 'SET_LOADING'})

       const getUserData = async() =>{

           const userData = await getUserAndRepos(params.login);

            dispatch({
              
              type: 'GET_USER_AND_REPOS', 
              payload: userData,
          
            })

       }

       getUserData()


    }, [])

    const {
        name,
        type,
        avatar_url,
        location,
        bio,
        blog,
        twitter_username,
        login,
        html_url,
        followers,
        following,
        public_repos,
        public_gists,
        hireable,
      } = user

 
      if(loading){

        return <Spinner />

      }


  return <>
   
     <div className=" w-full mx-auto lg:w-10/12">

        <div className="mb-4">

          <Link className='btn back3 text-slate-100 border-2 border-white hover:border-2 hover:border-white font-semibold  ml-1 w-30 text-sm ease-out duration-300 hover:scale-x-105 hover:scale-y-105 focus:outline-none border-purple-800' to="/">
            
          Back To Search</Link>

        </div>

          <div className="grid grid-cols-1 xl:grid-cols-3 
          lg:grid-cols-3 md:grid-cols-3 mb-8 md:gap-8">

                 <div className="custom-card-image mb-6 md:mb-0">

                     <div className="rounded-4xl shadow-md shadow-black card image-full">

                           <figure>

                               <img src={avatar_url} alt="Avatar_img" />
 
                           </figure>

                           <div className="card-body justify-end">

                             <h2 className="card-title mb-0">
                              {name}
 
                             </h2>
                             <p>{login}</p>

                           </div>
            

                    </div>


                 </div>


                <div className="col-span-2">

                   <div className="mb-6">

                   <h1 className="text-3xl card-title">

                     {name}

                     <div className="ml-2 mr-1 badge badge-error">
                     
                      {type}
                            
                     </div>
                
                      {hireable && (

                            <div className="mx-1 badge badge-info">
                              Hireable
                            </div>

                      )}
 
                     </h1>
                       <p>{bio}</p>

                       <div className="mt-4 card-actions">

                        <a href={html_url} target='_blank'
                         rel='noreferrer'
                         
                         className='btn btn-outline'>Visit Github Profile</a>

                       </div>

                   </div>

                        {/* location details */}

                        <div className="w-full grid overflow-hidden rounded-lg lg:grid-cols-3 grid-cols-1 shadow-md shadow-white">

                         { location && (

                            <div className="stat custom-background ">

                            <div className="text-lg font-custom  font-bold text-red">
 
                            Location

                            </div>

                              <div className="text-lg stat-value font-bold">{location}</div>

                            </div>


                         )}

                          { blog && (

                            <div className="stat custom-background ">

                            <div className="text-lg text-red font-custom  font-bold">
 
                            Website

                            </div>

                              <div className="text-lg stat-value font-bold">
                                
                                <a href={`https://${blog}`} target="_blank" rel='noreferrer'>{blog}</a>

                              </div>

                            </div>


                         )}


                       { twitter_username && (

                            <div className="stat custom-background ">

                            <div className=" text-lg text-red font-custom font-bold ">
 
                            Twitter

                            </div>

                              <div className="text-lg stat-value font-bold">
                                
                                <a href={`https://twitter.com/${twitter_username}`} target="_blank" rel='noreferrer'>{twitter_username}</a>

                              </div>

                            </div>


                         )}
                         
                        </div>
                   </div>

               </div>


           <div className="w-full py-5 mb-6 rounded-lg grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 overflow-hidden custom-background shadow-md  shadow-white">

                 <div className="stat custom-background">

                     <div className="stat-figure text-secondary">

                        <FaUsers className='text-3xl md:text-5xl' />

                     </div>
                     <div className="stat-title text-lg pr-5 font-bold">Followers</div>

                      <div className="stat-value pr-5 text-xl md:text-2xl">{followers}</div>

                  </div>


                    <div className="stat custom-background">

                     <div className="stat-figure text-secondary">

                        <FaUserFriends className='text-3xl md:text-5xl' />

                     </div>
                     <div className="stat-title text-lg pr-5 font-bold">Following</div>

                      <div className="stat-value pr-5 text-xl md:text-2xl">{following}</div>

                  </div>

                  
                    <div className="stat custom-background">

                     <div className="stat-figure text-secondary">

                        <FaCodepen className='text-3xl md:text-5xl' />

                     </div>
                     <div className="stat-title text-lg pr-5 font-bold">Public Repos</div>

                      <div className="stat-value pr-5 text-xl md:text-2xl">{public_repos}</div>

                  </div>
           
                  <div className="stat custom-background">

                     <div className="stat-figure text-secondary">

                        <FaStore className='text-3xl md:text-5xl' />

                     </div>
                     <div className="stat-title text-lg pr-5 font-bold">Public Gits</div>

                      <div className="stat-value pr-5 text-xl md:text-2xl">{public_gists}</div>

                  </div>




           </div>

           <RepoList  repos={repos}/>

           </div>
  
   
  
  </>;



}

export default User;
